import { CartSummaryProps } from "@made-people/blueprint-cart-summary";

export const CartSummary: CartSummaryProps = {
  templateProps: {
    template: "birch",
    cartTotalsSettings: {
      fieldsEnabled: {
        subtotal: true,
        discount: false,
        tax: false,
        shipping: true,
        grandTotal: true,
      },
    },
  },
};
